/* @flow */

import { createSlice } from '@reduxjs/toolkit';

// import * as types from './braindateActionTypes';
import { userLanguagesEndpoint } from 'src/shared/app/base/settings/endpointSettings';
import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';
import {
  setFetchingStateSlice,
  unsetFetchingStateSlice,
  setRequestSimpleResultSlice,
} from 'src/shared/core/util/reducerUtils';
import type { Methods } from 'src/shared/app/base/middleware/httpMethodMiddleware';
import type { GetState } from 'src/shared/core/type/reduxTypes';

export const languagesSlice = createSlice({
  name: 'languages',
  initialState: { isFetching: false, result: {} },
  reducers: {
    fetchLanguagesRequest: setFetchingStateSlice,
    fetchLanguagesSuccess: setRequestSimpleResultSlice,
    fetchLanguagesFailure: unsetFetchingStateSlice,
  },
});

export const {
  fetchLanguagesRequest,
  fetchLanguagesSuccess,
  fetchLanguagesFailure,
} = languagesSlice.actions;

export default languagesSlice.reducer;

export function fetchLanguages() {
  return (dispatch: any, _: GetState, { get }: Methods) => {
    dispatch(fetchLanguagesRequest());
    return get(userLanguagesEndpoint())
      .then(parseResponse)
      .then((result) => {
        dispatch(fetchLanguagesSuccess(result));
      })
      .catch((e) => {
        dispatch(fetchLanguagesFailure(e));

        throw e;
      });
  };
}
